export const commonConfig = {
  isDriverLastNameRequired: true,
  isGroupOperatorLastNameRequired: true,
  isParkingAdminLastNameRequired: true,
  isManagerLastNameRequired: true,
  encryptionKey: '',
  versions: {
    adminRoles: '4.7',
    driver: '3.7',
    groupOperator: '1.7',
  },
  googleMapsApiKey: '',
  appUrls: {
    android: 'test-url',
    ios: 'test-url',
  },
  mapUrls: {
    streetView: 'test-url',
    markerClusterImagePath: "test-url",
    googleMapsBase: "test-url",
  },
  truckIcon: "test-url",
  appId: '',
};

export const mockConfig = {
  mockObj: {
    oldPasswordPlaceholder: 'oldPass123',
    passwordPlaceholder: 'qwerty123',
    invalidPasswordPlaceholder: 'invalid123',
     mockUrl: 'https://trucklots.com',
  },
};

